export default (points = []) =>
  points
    .map(point => ({
      name: point.name,
      type: point.isAirport ? 'airport' : 'town',
      id: point.id ? point.id : point.code,
      code: point.code ? point.code : '',
      key: point.key,
      country: point.country,
      city: point.city,
      isRailwayStation: point.isRailwayStation,
    }))
    .slice(0, 20);
